import { includes } from 'lodash';

import { featureFlags } from 'common/featureFlags/featureFlags';
import { RoleVariantEnum, StudyDefaultPatientStatusEnum, UserSubType } from 'common/graphql/types';

const ACTIVE_STATUSES = [
    StudyDefaultPatientStatusEnum.Screened,
    StudyDefaultPatientStatusEnum.Rescreened,
    StudyDefaultPatientStatusEnum.Enrolled,
    StudyDefaultPatientStatusEnum.Randomized,
    StudyDefaultPatientStatusEnum.Consented,
    StudyDefaultPatientStatusEnum.Preconsent,
    StudyDefaultPatientStatusEnum.Reconsent,
];
const INACTIVE_STATUSES = [
    StudyDefaultPatientStatusEnum.ScreenFailed,
    StudyDefaultPatientStatusEnum.Completed,
    StudyDefaultPatientStatusEnum.Discontinued,
    StudyDefaultPatientStatusEnum.DidNotConsent,
    StudyDefaultPatientStatusEnum.Withdrew,
];

export const isPatientStatusInactive = (patientStatus: StudyDefaultPatientStatusEnum | string): boolean =>
    includes(INACTIVE_STATUSES, patientStatus);

export const isPatientStatusActive = (patientStatus: StudyDefaultPatientStatusEnum | string): boolean =>
    includes(ACTIVE_STATUSES, patientStatus);

export const isSiteUserReadOnly = (type: UserSubType) =>
    includes(
        [
            UserSubType.MONITOR,
            UserSubType.DATA_MANAGER,
            UserSubType.INSPECTOR,
            UserSubType.PRODUCT_SUPPORT,
            UserSubType.DATA_CHANGE_SUPPORT,
        ],
        type
    );

export const isSupportDcrUserSubType = (subType?: UserSubType | null): boolean =>
    includes([UserSubType.PRODUCT_SUPPORT, UserSubType.DATA_CHANGE_SUPPORT], subType);

export const getFxEnabledRoles = (): RoleVariantEnum[] => {
    return featureFlags.fxIntegration ? [RoleVariantEnum.ProductSupport] : [];
};
